import formComponent from '@/util/proto/formComponent'

export default {
  extends: formComponent,
  data() {
    return {
      formData: {
        title: {
          rules: [
            { required: true, message: '请输入类型名称', trigger: 'blur,change' },
          ]
        },
        companyIds:{
          initialValue:[],
          rules: [
            { required: true,type: 'array',  message: '请选择巡检网点', trigger: 'blur,change' },
          ]
        },
        organizationId: {
          rules: [
            { required: true,type: 'number',  message: '请选择所属单位', trigger: 'blur,change' },
          ]
        },
        
        inspectionState:{
          rules: [
            { required: true,type: 'number',  message: '请选择巡检状态', trigger: 'blur,change' },
          ]
        }
      },
      
      id: null,
      loading: false,
      visible: false,
      raw:{},
      api:['companyInspectionCreate','companyInspectionUpdate']
    }
  },

  created() {

  },
  computed: {
    itemTitle() {
      return this.id ? '编辑巡检信息' : '新增巡检信息'
    },
    companyInspectionIdsDecorator(){
       
      let companyInspectionState = this.form ? this.form.getFieldValue('inspectionState') : null
      return [
        'companyInspectionIds',
        {
          initialValue:this.companyInspectionIds || null,
          rules:[
            { type:'array', required: companyInspectionState == 1 , message: '请选择巡检类型', trigger: 'blur,change' },
            // { message: '请输入保修期限', trigger: 'blur,change' },
          ]
        }
      ]
    },
    inspectionTypes(){
      return this.$request.companyInspectionTypes({search:{pageSize:1e4}}).then( resp => {
        return Promise.resolve( (resp.data.list || [] ).map(i => ({value:i.id , label:i.name})))
      })
    }
  },

  methods: {
    init(id) {
      this.id = id
      this.reset()
      this.visible = true
      if (this.id) {
        this.query()
      }
    },

    query() {
      this.loading = true
      this.$request.companyInspection(this.id).then(resp => {
        this.loading = false
        resp.data.companyIds = (resp.data.details || []).map(i => i.companyId )
        resp.data.companyInspectionIds = Array.from(new Set((resp.data.details || []).map(i => i.companyInspectionId )))
        this.raw = resp.data

        this.$setFormData(resp.data)
        this.form.setFieldsValue({companyInspectionIds:this.raw.companyInspectionIds})
      })
    },
    reset() {
      this.$resetFormData()
    },

    beforeSave(d){
      if(this.id) d.id = this.id
      return d
    }

  },

  render(){
    let inspectionState = this.form ? this.form.getFieldValue('inspectionState') : null
    return  <sl-side-panel v-model={this.visible} loading={this.loading} mask-closable={false} title={this.itemTitle}>
        <sl-form label-width={110}>
          <sl-form-item label="巡检标题">
            <Input v-decorator={this.formData.title} maxlength={128}></Input>
          </sl-form-item>
          <sl-form-item label="巡检网点">
            <sl-select dict="company" multiple={true} filterable={true} placeholder="选择巡检网点" v-decorator={this.formData.companyIds} />
          </sl-form-item>
          <sl-form-item label="所属单位">
            <sl-select dict="org" filterable={true} placeholder="选择所属单位" v-decorator={this.formData.organizationId}/>
          </sl-form-item>
          <sl-form-item label="巡检状态">
            <sl-select dict="companyInspectionState" type="radio" v-decorator={this.formData.inspectionState} />
          </sl-form-item>
          <sl-form-item label="巡检类型" v-show={inspectionState == 1}>
            <sl-select dict={this.inspectionTypes} multiple={true} v-decorator={this.companyInspectionIdsDecorator} />
          </sl-form-item>
        </sl-form>
        <div slot="footer">
          <Button loading={this.loading} on-click={this.$handleSubmit} type="primary">确定</Button>
        </div>
    </sl-side-panel>
  }
}



export const View = {
  data() {
    return {
      data: {},
      visible:false,
    }
  },


  methods: {

    init(id) {
      this.id = id
      this.visible = true
      if (this.id) {
        this.query()
      }
    },

    query() {
      this.$request.companyInspection(this.id).then(resp => {
        this.data = this.$utils.conv(resp.data , {'inspectionState':'companyInspectionState'})
      })
    }
  },

  render(){
    const data = this.data || {}
    //col={3} layout="vertical"

    const title = '查看类型'
    return (
      <sl-side-panel v-model={this.visible} mask-closable={false} title={title}>
        <sl-detail-list label-width="80px" col={1} label-align="right" style="padding:12px;">
          <sl-detail-list-item title="巡检标题" content={data.title} />
          
          <sl-detail-list-item title="巡检网点">
            {
               (data.details || []).map(i => <div>{i.companyName}</div>)
            }
          </sl-detail-list-item>

          <sl-detail-list-item title="所属单位" content={data.organizationName} />
          <sl-detail-list-item title="巡检状态" content={data.inspectionStateText} />

        </sl-detail-list>
      </sl-side-panel>
    )
  }
}